import React from 'react';
import DatePicker from 'react-datepicker';
import {Icon, Input} from 'semantic-ui-react';
import moment from 'moment';
import './styles.scss';
import {FLOATING_DEALERS} from '../../../budgetVehicles/constants';

const SelectedCard = ({data, labels, updateMyData, selectedPriorizationDates, suggestedDates,
  changeSelectedPrioritizationDate}) => {
  const getSelectedPriorizationDate = (chassis) => {
    const selectedDateItem = selectedPriorizationDates.find((x) => x.chassis === chassis);
    const dateFormatted = selectedDateItem?.selectedDate &&
      moment(selectedDateItem.selectedDate, 'DD-MM-YYYY').toDate();

    return dateFormatted;
  };

  const getIncludedDates = () => {
    const {reservationId} = data[0];
    return reservationId !== FLOATING_DEALERS.tde ?
      suggestedDates?.filter((x) => (x.dayliQuotation - x.quotationDisablePriorization) > 0)
        .map((x) => new Date(x.date)) :
      suggestedDates?.map((x) => new Date(x.date));
  };

  return (
    <>
      {
        data.map((line, indexi) => {
          return (
            <div key={indexi} className='priorization-selected-card-container'>
              <table cellPadding="0" cellSpacing="0" className='priorization-selected-card-table'>
                <tbody>
                  {
                    Object.entries(labels).map((entry, indexj) => {
                      const [key, label] = entry;
                      if (indexj === 0) {
                        return (
                          <tr key={indexj}>
                            <td className='priorization-selected-card-label'>{label}:</td>
                            <td>
                              <div className='priorization-selected-card-first-item'>
                                <span className='priorization-selected-card-value'>&nbsp;{line[key]}</span>
                                <div
                                  className='priorization-selected-card-delete pointer'
                                  onClick={() => updateMyData(line.index, 'isSelected', false)} >
                                  &times;
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      }
                      return (
                        <tr key={indexj}>
                          <td className='priorization-selected-card-label no-spaces'><span>{label}:</span></td>
                          <td><span className='priorization-selected-card-value'>&nbsp;{line[key]}</span></td>
                        </tr>
                      );
                    }
                    )
                  }
                  <tr>
                    <td className='priorization-selected-card-label no-spaces'><span>FECHA FACT.:</span></td>
                    <td>
                      <DatePicker style={{'padding': '0 !important'}}
                        dateFormat={'dd/MM/yyyy'}
                        placeholderText="SELECCIONAR..."
                        disabledKeyboardNavigation
                        disabled={!(suggestedDates && suggestedDates.length > 0)}
                        customInput={
                          <Input type="text" icon={<Icon name='calendar' size='big' disabled={true}
                            style={{'marginRight': '-10px'}} />} size='small' />
                        }
                        selected={getSelectedPriorizationDate(line.chassis)}
                        includeDates={getIncludedDates()}
                        highlightDates={suggestedDates?.filter((x) =>
                          (x.dayliQuotation - x.quotationDisablePriorization) > 0)
                          .map((x) => {
                            return new Date(x.date);
                          })}
                        locale="es"
                        onChange={(value) => changeSelectedPrioritizationDate(value, line.chassis)}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          );
        }
        )
      }
    </>
  );
};

export default SelectedCard;
